
import { IFreelancer } from '../data_models/freelancer';
import { IEmployer } from '../data_models/employer';
import { USER_ENDPOINTS } from '../config/apiEndpoints';
import axios from 'axios';
import useAuth from './useAuth';

function useUser() {

    const { authToken } = useAuth();

    const fetchFreelancerById = async (id: string): Promise<IFreelancer> => {
        try {
            const response = await axios.get(`${USER_ENDPOINTS.GET_FREELANCER_BY_ID}/${id}`, {
                headers: {
                    Authorization: `${authToken}`,
                },
            });
            return response.data;
        } catch (error: any) {
            // Check if the error has a response and a data property
            if (error.response && error.response.data && error.response.data.error) {
                throw new Error(error.response.data.error); // Access the error message
            } else {
                throw new Error('An unexpected error occurred');
            }
        }
    }

    const fetchBriefFreelancersByIds = async (ids: string[]): Promise<IFreelancer[]> => {
        try {
            const response = await axios.post(USER_ENDPOINTS.POST_FREELANCERS_MULTIPLE_BRIEF,
                { ids },
                {
                    headers: {
                        Authorization: `${authToken}`,
                    },
                });
            return response.data;
        } catch (error: any) {
            // Check if the error has a response and a data property
            if (error.response && error.response.data && error.response.data.error) {
                throw new Error(error.response.data.error); // Access the error message
            } else {
                throw new Error('An unexpected error occurred');
            }
        }
    }


    const fetchFullFreelancersByIds = async (ids: string[]): Promise<IFreelancer[]> => {
        try {
            const response = await axios.post(USER_ENDPOINTS.POST_FREELANCERS_MULTIPLE_FULL,
                { ids },
                {
                    headers: {
                        Authorization: `${authToken}`,
                    },
                });
            return response.data;
        } catch (error: any) {
            // Check if the error has a response and a data property
            if (error.response && error.response.data && error.response.data.error) {
                throw new Error(error.response.data.error); // Access the error message
            } else {
                throw new Error('An unexpected error occurred');
            }
        }
    }


    const fetchFreelancersByFilter = async (filter: any, page: number, limit: number): Promise<{ freelancers: IFreelancer[], totalPages: number, totalDocuments: number }> => {
        try {
            const response = await axios.post(USER_ENDPOINTS.POST_FREELANCER_BY_FILTER,
                {
                    filter: filter,
                    page: page,
                    limit: limit
                },
                {
                    headers: {
                        Authorization: `${authToken}`,
                    },
                });
            return response.data;
        } catch (error: any) {
            // Check if the error has a response and a data property
            if (error.response && error.response.data && error.response.data.error) {
                throw new Error(error.response.data.error); // Access the error message
            } else {
                throw new Error('An unexpected error occurred');
            }
        }
    }

    const fetchEmployerById = async (id: string): Promise<IEmployer> => {
        try {
            const response = await axios.get(`${USER_ENDPOINTS.GET_EMPLOYER_BY_ID}/${id}`, {
                headers: {
                    Authorization: `${authToken}`,
                },
            });
            return response.data
        } catch (error: any) {
            // Check if the error has a response and a data property
            if (error.response && error.response.data && error.response.data.error) {
                throw new Error(error.response.data.error); // Access the error message
            } else {
                throw new Error('An unexpected error occurred');
            }
        }
    }

    const fetchBriefEmployerByIds = async (ids: string[]): Promise<IEmployer[]> => {
        try {
            const response = await axios.post(USER_ENDPOINTS.POST_EMPLOYERS_MULTIPLE_BRIEF,
                { ids },
                {
                    headers: {
                        Authorization: `${authToken}`,
                    },
                });
            return response.data;
        } catch (error: any) {
            // Check if the error has a response and a data property
            if (error.response && error.response.data && error.response.data.error) {
                throw new Error(error.response.data.error); // Access the error message
            } else {
                throw new Error('An unexpected error occurred');
            }
        }
    }

    const searchFreelancers = async (searchTerm: string, maxResults?: number): Promise<IFreelancer[]> => {
        try {
            const response = await axios.post(USER_ENDPOINTS.POST_SEARCH_FREELANCERS,
                { searchTerm, maxResults },
                {
                    headers: {
                        Authorization: `${authToken}`,
                    },
                });
            return response.data;

        } catch (error: any) {
            // Check if the error has a response and a data property
            if (error.response && error.response.data && error.response.data.error) {
                throw new Error(error.response.data.error); // Access the error message
            } else {
                throw new Error('An unexpected error occurred');
            }
        }
    }

    return {
        fetchFreelancerById,
        fetchBriefFreelancersByIds,
        fetchFullFreelancersByIds,
        fetchFreelancersByFilter,
        fetchEmployerById,
        fetchBriefEmployerByIds,
        searchFreelancers,
    };
}

export default useUser;
